import { create, tsx } from '@dojo/framework/core/vdom';

import { Link } from '@dojo/framework/routing/Link';
import router from '../middleware/router';
import * as css from './Navigation.m.css';
import { RenderResult } from '@dojo/framework/core/interfaces';

const sitepenLogo = require('../assets/images/nav-footer-images/sitepen_logo_dark.svg');

const notch = require('../assets/images/nav-footer-images/nav-arrow-with-shadow.png');
const arrowLeft = require('../assets/images/icon-solid/angle-left.svg');

const factory = create({ router });

const DropDownItem = create()
	.children<{ title: string; description: RenderResult }>()
	.properties<{ to: string }>()(function DropDownItem({ properties, children }) {
	const { to } = properties();
	const [{ title, description }] = children();

	return (
		<Link
			to={to}
			isOutlet={!!to}
			tabIndex={0}
			classes={['navigation-menu-link', css.sectionLink]}
		>
			<div classes={[css.sectionTitle, css.sectionItemPadding]}>{title}</div>
			<div classes={[css.sectionItem, css.sectionItemPadding]}>{description}</div>
		</Link>
	);
});

export const Navigation = factory(function Navigation({ middleware: { router } }) {
	return (
		<header id="site-navigation-header" classes={[css.root]}>
			<div classes={[css.wrapper]}>
				<div classes={[css.logoContainer]}>
					<div classes={[css.logo]}>
						<a classes={[css.logoLink]} href="/" id="logo" title="Home">
							<img
								classes={[css.logoImage]}
								loading="lazy"
								src={sitepenLogo}
								alt=""
								height={40}
								width={145}
							/>
						</a>
					</div>
					<button
						type="button"
						id="menuButton"
						classes={[css.menuButton]}
						aria-expanded="false"
						aria-label="Navigation menu"
						aria-controls="site-navigation"
					>
						<div classes={['toggleBar', css.toggleBar]} />
					</button>
				</div>
				<nav id="site-navigation" classes={[css.navigation]}>
					<button
						id="navigation-back-button"
						type="button"
						classes={['headerBackButton', css.backButton]}
					>
						<img classes={css.backButtonChevron} src={arrowLeft} alt="" />
						<span classes={css.backButtonLabel}>Back</span>
					</button>
					<ul classes={[css.navMenu]}>
						<li tabIndex={0} classes={[css.navItem, 'navigation-item']}>
							<button
								aria-controls="what-we-do-menu"
								aria-expanded="false"
								classes={[css.navButton]}
							>
								What We Do
							</button>
							<img
								src={notch}
								classes={[css.dropDownNotch, 'drop-down-menu-notch']}
							/>
							<div
								tabIndex={0}
								id="what-we-do-menu"
								classes={[css.dropDown, 'drop-down-content']}
							>
								<div classes={[css.dropDownHeader]}>
									<Link to="services" classes={[css.dropDownTitle]}>
										What We Do
									</Link>
									<Link to="services" classes={[css.learnMore]}>
										Learn more about our services
									</Link>
								</div>
								<Link to="services" classes={[css.downContentMenuMobileTitleLink]}>
									What We Do
								</Link>
								<div classes={[css.dropDownContent, css.threeColumnGrid]}>
									<DropDownItem to="servicesCustomSoftwareDevelopment">
										{{
											title: 'App Development',
											description:
												'End-to-end and cross-platform software solution delivery'
										}}
									</DropDownItem>
									<DropDownItem to="servicesEnterpriseUX">
										{{
											title: 'UI | UX Design',
											description:
												'Rapid prototyping and user experience design services'
										}}
									</DropDownItem>
									<DropDownItem to="servicesQualityAssurance">
										{{
											title: 'Quality Assurance',
											description:
												'Performance analysis, optimization, and test automation'
										}}
									</DropDownItem>
									<DropDownItem to="servicesEnterpriseDevOpsSolutions">
										{{
											title: 'Cloud and DevOps Engineering',
											description:
												'Infrastructure engineering and delivery automation'
										}}
									</DropDownItem>
									<DropDownItem to="expertiseAgileConsulting">
										{{
											title: 'Process and Culture',
											description:
												'Agile consulting and delivery process optimization'
										}}
									</DropDownItem>
									<DropDownItem to="servicesEnterpriseTechnologyStrategy">
										{{
											title: 'Strategy and Architecture',
											description:
												'Design or appraisal of strategies and solution architectures'
										}}
									</DropDownItem>
								</div>
							</div>
						</li>

						<li classes={[css.desktopNavItem, css.navItem, 'navigation-item']}>
							<Link tabIndex={0} to="work" classes={[css.navButton]}>
								Our Work
							</Link>
						</li>

						<li classes={[css.mobileNavItem, css.navItem, 'navigation-item']}>
							<Link to="work" classes={[css.navButton]}>
								Our Work
							</Link>
						</li>

						<li classes={[css.desktopNavItem, css.navItem, 'navigation-item']}>
							<Link tabIndex={0} to="blog" classes={[css.navButton]}>
								Insights
							</Link>
						</li>

						<li classes={[css.mobileNavItem, css.navItem, 'navigation-item']}>
							<Link to="blog" classes={[css.navButton]}>
								Insights
							</Link>
						</li>

						<li classes={[css.desktopNavItem, css.navItem, 'navigation-item']}>
							<Link to="contact" classes={[css.contactUsButton]}>
								Contact Us
							</Link>
						</li>

						<li classes={[css.mobileNavItem, css.navItem, 'navigation-item']}>
							<Link to="contact" classes={[css.navButton]}>
								Contact
							</Link>
						</li>
					</ul>
				</nav>
			</div>
		</header>
	);
});

export default Navigation;
